export default __webpack_public_path__ + "static/leave-review-950083fa9e760ee247ceccb04a8a5a0f.png";